import { ResendOTPMdl } from './../../Models/ResendOTPMdl';
import { userService } from './../../Services/userService';
import { QuoteModelMdl } from './../../Models/QuoteBindMdl';
import { OtpVerifyRes } from '../../Models/OtpVerifyRes';
import { MotorStatusMdl } from '../../Models/MotorStatusMdl';
import { Component, ViewChild, ElementRef, OnInit } from '@angular/core';
import { RouterModule, Routes, Router } from '@angular/router';
import { AddNewPolicyMdl } from '../../Models/AddNewPolicy';
import { InsuredMdl } from '../../Models/InsuredMdl';
import { RegistrationMdl } from '../../Models/RegistrationMdl';
import { restURL } from '../../Models/restURL';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import "rxjs/add/observable/timer";
import "rxjs/add/operator/finally";
import "rxjs/add/operator/takeUntil";
import "rxjs/add/operator/map";
import { OtpVerifyReq } from '../../Models/OtpVerifyReq';
import { loginRes } from '../../Models/loginRes';
import { loginReq } from '../../Models/loginReq';
import { QuoteBindMdl } from '../../Models/QuoteBindMdl';
import { QuoteReqMdl, QuoteResMdl } from '../../Models/QuoteReqMdl';
import { Subscription } from 'rxjs';
import { LanguageService } from '../../Services/languageService';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { mdlPayloadRequest } from '../../Models/mdlPayloadRequest';
import { mdlPayloadResponse } from '../../Models/mdlPayloadResponse';
import { motorProposalService } from '../../Services/motorProposalService';
import { mdlClaimStatusNewReq, mdlClaimStatusReq } from '../../Models/Claims';
import { mdlClaimStatus, mdlGetClaimStatusRes } from '../../Models/mdlGetClaimStatusRes ';
import swal from "sweetalert2";
import { mdlClaimStatusNew, mdlCliamDocumentListNew, mdlGetClaimStatusNewRes } from '../../Models/mdlGetClaimStatusNewRes';
import { mdlGetMobilenoVerificationRes } from '../../Models/mdlGetMobilenoVerificationRes';

// import * as $ from 'jquery';
declare let $: any;
@Component({
  selector: 'NewReg',
  templateUrl: './NewReg.html',
  styleUrls: ['./NewReg.css']
})
export class NewReg implements OnInit {
  //public httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json','Accept-Encoding': 'gzip' }) };
  public apiUrl: restURL = new restURL();
  public regObj: RegistrationMdl = new RegistrationMdl();
  public Insured: boolean = true;
  public MM: string;
  public YYYY: string;
  public showOTP: boolean;
  public st: MotorStatusMdl = new MotorStatusMdl();
  public showLoading: boolean = false;
  public showLoginLoading: boolean = false;
  public FormName: string;
  public isCheckAgreed: boolean = false;
  public isResendShow: boolean = false;
  public isShowTimer: boolean = false;
  public CurrentTime: number;
  public RemainTime: number;
  public otpReq: OtpVerifyReq = new OtpVerifyReq();
  public otpRes: OtpVerifyRes = new OtpVerifyRes();
  public loginStObj: loginRes = new loginRes();
  public loginReqObj: loginReq = new loginReq();
  public quoteBind: QuoteBindMdl = new QuoteBindMdl();
  public fiteredModels: Array<QuoteModelMdl> = new Array<QuoteModelMdl>();
  public quoteReq: QuoteReqMdl = new QuoteReqMdl();
  public quoteRes: QuoteResMdl = new QuoteResMdl();
  public LngSubscription: Subscription;
  public resendObj: ResendOTPMdl = new ResendOTPMdl();
  public Lng: string;
  public QuoteStatus: boolean = true;
  public isLockFields: boolean = false;
  public counter: number = 0;
  public objPayloadRequest: mdlPayloadRequest = new mdlPayloadRequest();
  public objPayloadResponse: mdlPayloadResponse = new mdlPayloadResponse();
  public CaptchaCode: string = "";
  public EnteredCaptchaCode: string = "";
  public objSearchReq: mdlClaimStatusNewReq = new mdlClaimStatusNewReq();
  private _ClaimStatusRes: mdlGetClaimStatusNewRes = new mdlGetClaimStatusNewRes();
  public get ClaimStatusRes_1(): mdlGetClaimStatusNewRes {
    return this._ClaimStatusRes;
  }
  public set ClaimStatusRes_1(value: mdlGetClaimStatusNewRes) {
    this._ClaimStatusRes = value;
  }
  public get ClaimStatusRes(): mdlGetClaimStatusNewRes {
    return this._ClaimStatusRes;
  }
  public set ClaimStatusRes(value: mdlGetClaimStatusNewRes) {
    this._ClaimStatusRes = value;
  }
  public CurrentClaimStatus: Array<mdlClaimStatusNew> = new Array<mdlClaimStatusNew>();
  public TempDocumentList:Array<mdlCliamDocumentListNew> =new Array<mdlCliamDocumentListNew>();
  public YakeenMobileres:mdlGetMobilenoVerificationRes=new mdlGetMobilenoVerificationRes();
  public ShowClaimStatus: boolean = false;
  public isShowLoading: boolean;
  public Lang: any;
  public SerachByValue:string="";
  public SearchTextValue:string="";
  public isCheckAgreed2: boolean = false;
  public isCheckAgreed3: boolean = false;
  @ViewChild('captcha') dvCaptcha: ElementRef;

  constructor(private translate: TranslateService,private EncriptService: motorProposalService, public Translate: TranslateService, private router: Router, private http: HttpClient, private url: restURL, private lngService: LanguageService, private userInfo: userService) {
    this.LngSubscription = this.lngService.grtLng().subscribe(lng => { this.Lng = lng });
    this.FormName = "Insured Information";

    if (sessionStorage.getItem("Language") != null) {
      this.Lng = sessionStorage.getItem("Language");
    }
    else {
      this.Lng = "en";
    }
    this.Lang=this.Lng;
    this.showOTP = false;
    this.showLoading = false;
    this.showLoginLoading = false;
    this.isResendShow = false;
    this.RemainTime = 180;
    this.isShowTimer = false;
    this.isLockFields = false;
    // this.bindQuote();

  }
  ngOnInit() {
    this.CreateCaptcha()
    window.scrollTo(0, 0);
  }
  // ngAfterViewChecked() {
  //   window.scrollTo(0, 0);
  //   }
  showOTPTimer() {
    //300000
    this.isShowTimer = true;
    let seconds: number = 1000;
    Observable.timer(0, seconds).takeUntil(Observable.timer(180000)).finally(() => {
      this.isResendShow = true;
      this.CurrentTime = 0;
    }).subscribe(t => this.CurrentTime = this.RemainTime - t);
  }
  verifyOTP() {

    this.otpReq.RegNo = Number(sessionStorage.getItem("RegNo"));
    this.showLoading = true;

    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.otpReq));

    //this.http.post<OtpVerifyRes>(this.url.baseURL + "Registration/VerifyOTP", this.otpReq, this.userInfo.getHttpOptions()).toPromise().then(result => {
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "Registration/VerifyOTP", this.objPayloadRequest, this.userInfo.getHttpOptions()).toPromise().then(result => {
      //this.otpRes = result;

      //New Line Start
      this.objPayloadResponse = result;
      this.otpRes = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
      //NewLine End
      //this.Lng == "ar" ? alert(this.otpRes.st.StatusDescAr) : alert(this.otpRes.st.StatusDesc);

      Swal(this.Translate.instant(this.otpRes.st.StatusDesc));
      if (this.otpRes.st.StatusCode === "S") {
        //alert(this.loginStObj.token);   
        this.userInfo.setToken(this.otpRes.token);
        sessionStorage.setItem("IqamaNo", this.otpRes.IqamaNo);
        sessionStorage.setItem("RegNo", this.otpRes.Regno.toString());
        sessionStorage.setItem("Lng", this.otpRes.Lng);
        sessionStorage.setItem("InsuredName", this.otpRes.InsuredName);
        sessionStorage.setItem("InsuredNameAr", this.otpRes.InsuredNameAr);
        sessionStorage.setItem("NameAr", this.otpRes.InsuredNameAr);
        sessionStorage.setItem("NatEn", this.otpRes.Nationality);
        sessionStorage.setItem("NatAr", this.otpRes.NationalityAr);
        sessionStorage.setItem("InsuredToken", this.otpRes.Insuredtoken);

        this.router.navigate(['/NewDashboard/Welcome']);
      }
      else {
        if (this.otpRes.st.Result === "E") {
          this.isShowTimer = true;
          this.CurrentTime = 0;
          this.isResendShow = true;
          this.showOTPTimer();
        }
        else if (this.otpRes.st.Result === "5A") {
          this.showOTP = false;
          this.isShowTimer = false;
        }
      }
      this.showLoading = false;
    }, (error) => {
      this.showLoading = false;
      Swal(this.Translate.instant("Please Try agian later."));
    });
  }

  ClearQuote() {
    this.quoteRes.st.StatusCode = null;
    this.quoteReq.MobileNo = "";
    this.quoteReq.Make = "";
    this.quoteReq.Model = "";
    this.quoteReq.DEDUCTIBLE_CODE = "0";
    this.quoteReq.VehcileUsage = "";
    this.quoteReq.VehcileAge = "";
    this.QuoteStatus = true;

  }
  async login() {
    this.showLoading = true;
    // await this.http.get('https://api.ipify.org/?format=json').toPromise().then(
    //   (result) => {
    //     this.loginReqObj.IpAddress = JSON.parse(JSON.stringify(result)).ip;
    //   }, (error) => { }
    // );
    this.http.get('https://api.ipify.org/?format=json').toPromise().then(
      (result) => {
        this.loginReqObj.IpAddress = JSON.parse(JSON.stringify(result)).ip;
      }, (error) => { }
    );
    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.loginReqObj));

    //this.http.post<loginRes>(this.apiUrl.baseURL + "/Registration/Login", this.loginReqObj, this.userInfo.getHttpOptions()).toPromise().then((result) => {
    this.http.post<mdlPayloadResponse>(this.apiUrl.baseURL + "/Registration/Login", this.objPayloadRequest, this.userInfo.getHttpOptions()).toPromise().then((result) => {
      //this.loginStObj = result;

      //New Line Start
      this.objPayloadResponse = result;
      this.loginStObj = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
      //NewLine End

      if (this.loginStObj.st.StatusCode === "S") {
        sessionStorage.setItem("token", this.loginStObj.token);
        sessionStorage.setItem("IqamaNo", this.loginStObj.IqamaNo);
        sessionStorage.setItem("RegNo", this.loginStObj.RegNo.toString());
        sessionStorage.setItem("Lng", this.loginStObj.Lng);
        sessionStorage.setItem("CurrentRoute", "Welcome");
        this.router.navigate(['/NewDashboard/Welcome']);
      }
      else {
        this.Lng == "ar" ? alert(this.loginStObj.st.StatusDescAr) : alert(this.loginStObj.st.StatusDesc);
      }

      this.showLoading = false;
    }, (error) => {

      this.showLoading = false;
    });
  }
  ResendOTP() {
    this.showLoading = true;
    this.counter += 1;
    if (this.counter > 5) {
      Swal(this.Translate.instant("Maximum resend attempts reached. Please try again later"));
      return;
    }
    //alert("Test");
    this.resendObj.RegNo = sessionStorage.getItem("RegNo");

    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.resendObj));

    //this.http.post<MotorStatusMdl>(this.url.baseURL + "Registration/ResendOTP", this.resendObj, this.userInfo.getHttpOptions()).toPromise().then((res) => {
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "Registration/ResendOTP", this.objPayloadRequest, this.userInfo.getHttpOptions()).toPromise().then((res) => {
      //this.st = res;

      //New Line Start
      this.objPayloadResponse = res;
      this.st = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
      //NewLine End

      this.Lng == "ar" ? Swal(this.st.StatusDescAr) : Swal(this.st.StatusDesc);
      if (this.st.StatusCode == "S") {
        this.showOTPTimer();
        this.isResendShow = false;

      }
      this.showLoading = false;
    }, (res) => {
      Swal("Try agian");
      this.showLoading = false;

    });
  }

  ngAfterViewInit() {

    $(document).ready(function () {

      $('[data-toggle="popover"]').popover({
        placement: 'top',
        trigger: 'hover'
      });
    });
  }

  Quote() {
    this.ngAfterViewInit();
    this.FormName = "Quotation Details";
    /* if(this.Lng=="en")
     {
       this.FormName = "اقتبس التفاصيل";
     }*/
    this.Insured = false;
  }

  Inusred() {
    this.ngAfterViewInit();

    this.FormName = "Insured Information";
    /*if(this.Lng=="en")
    {
      this.FormName = "المؤمن المعلومات";
    }*/
    this.Insured = true;
  }
  bindQuote() {
    this.showLoading = true;
    this.http.get<QuoteBindMdl>(this.url.baseURL + "/Quote/getQuoteBind").toPromise().then((res) => {
      this.quoteBind = res;
      this.showLoading = false;
    },
      (error) => {
        this.showLoading = false;
        Swal("Please Try agian later");
      }
    )
  }

  generateQuote(val) {

    if (val) {
      this.showLoading = true;
      this.http.post<QuoteResMdl>(this.url.baseURL + "Quote/getQuote", this.quoteReq, this.userInfo.getHttpOptions()).toPromise().then(
        (result) => {
          this.quoteRes = result;
          if (this.quoteRes.st.StatusCode == "S") {
            this.QuoteStatus = false;
          }
          this.showLoading = false;
        },
        (error) => {
          this.showLoading = false;
        }

      );
    }
  }

  getMakes(make) {
    this.fiteredModels = this.quoteBind.modelList.filter(t => t.MakeCode == make);

  }
  AddReg() {

    if (this.regObj.EmailId != null) {
      if (this.regObj.EmailId.substring(this.regObj.EmailId.length - 3, this.regObj.EmailId.length).toLocaleUpperCase() != 'COM' && this.regObj.EmailId.substring(this.regObj.EmailId.length - 3, this.regObj.EmailId.length).toLocaleUpperCase() != '.SA') {
        Swal("Error", "Invalid Email Format", "error");
        return;
      }
    }


    if (this.regObj.InsuredIdNo.startsWith("1")) {
      this.regObj.IdExpiry = this.MM + "-" + this.YYYY;
    }
    else {
      this.regObj.DOB = this.MM + "-" + this.YYYY;
    }

    if (sessionStorage.getItem("Language") != null) {
      this.regObj.Lng = sessionStorage.getItem("Language");
    }
    else {
      this.regObj.Lng = "en";
    }

    if (this.isCheckAgreed3 == true) {
      this.regObj.IsAgreedNotification = true
    }
    else {
      this.regObj.IsAgreedNotification = false
    }

    if (this.EnteredCaptchaCode != this.CaptchaCode) {
      Swal("Invalid Captcha. try Again");
      this.EnteredCaptchaCode = "";
      this.CreateCaptcha();
      return;
    }
    this.http.get('https://api.ipify.org/?format=json').toPromise().then(
      (result) => {
        this.regObj.IpAddress = JSON.parse(JSON.stringify(result)).ip;
      }, (error) => { }
    );
    this.showLoading = true;

    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.regObj));

    //this.http.post<MotorStatusMdl>(this.url.baseURL + "Registration/AddRegistration", this.regObj, this.userInfo.getHttpOptions()).toPromise().then(result => {
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "Registration/AddRegistration", this.objPayloadRequest, this.userInfo.getHttpOptions()).toPromise().then(result => {
      //this.st = result;

      //New Line Start
      this.objPayloadResponse = result;
      this.st = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
      //NewLine End

      this.showLoading = false;
      if (this.st.StatusCode === "S") {
        //this.Lng == "ar" ? alert(this.st.StatusDescAr) : alert(this.st.StatusDesc);
        Swal(this.Translate.instant(this.st.StatusDesc))
        this.isLockFields = true;
        sessionStorage.setItem("RegNo", this.st.Result);
        this.showOTP = true;
        this.showOTPTimer();
      }
      else if (this.st.StatusCode === "F" && this.st.msgKey === "Error1") {
        Swal(this.Translate.instant(this.st.StatusDesc))
      } else {
        Swal({
          title: this.Translate.instant(this.st.StatusDesc),
          text: '',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.Translate.instant('Go To Login Page'), //this.Lng == "ar" ?'Go To Login Page' : 'Go To Login Page',
          cancelButtonText: this.Translate.instant('Forgot Login Details'),//this.Lng == "ar" ?'Forgot Password?' : 'Forgot Password?',
          showCloseButton: true
        }).then((result) => {
          if (result.value == true) {
            this.router.navigate(['/BeforeLogin/Login']);
          }
          else if (result.dismiss === Swal.DismissReason.cancel) {
            sessionStorage.setItem("ForgotPassword", "TRUE");
            this.router.navigate(['/BeforeLogin/Login']);
          }
        })
      }
    }, (error) => {
      this.showLoading = false;
      Swal("Please Try agian later.");
    });
  }

  CreateCaptcha() {
    // var code;
    //clear the contents of captcha div first

    // window.document.getElementById('captcha').innerHTML = "";

    this.dvCaptcha.nativeElement.innerHTML = "";
    var charsArray =
      "0123456789";
    var lengthOtp = 6;
    var captcha = [];
    for (var i = 0; i < lengthOtp; i++) {
      //below code will not allow Repetition of Characters
      var index = Math.floor(Math.random() * charsArray.length + 1); //get the next character from the array
      if (captcha.indexOf(charsArray[index]) == -1)
        captcha.push(charsArray[index]);
      else i--;
    }
    var canv = document.createElement("canvas");
    canv.id = "captcha";
    canv.width = 100;
    canv.height = 35;
    canv.className = "captcha";
    canv.style.position = "relative";
    canv.style.top = "-6px";
    canv.style.left = "8px";


    var ctx = canv.getContext("2d");
    ctx.font = "25px Georgia";
    ctx.strokeText(captcha.join(""), 0, 30);
    //storing captcha so that can validate you can save it somewhere else according to your specific requirements
    this.CaptchaCode = captcha.join("");
    // document.getElementById("captcha").appendChild(canv); 
    // adds the canvas to the body element
    this.dvCaptcha.nativeElement.appendChild(canv);
  }




  GetCalimStatus() {
    this.objSearchReq = new mdlClaimStatusNewReq();
    this.objSearchReq.ParameterKey=this.SerachByValue;
    this.objSearchReq.ParameterValue=this.SearchTextValue;
    this.showLoading = true;
    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.objSearchReq));
    this.isShowLoading = true;
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "Claims/GetClaimStatusNew", this.objPayloadRequest, this.userInfo.getHttpOptions()).toPromise().then((result) => {
        this.isShowLoading = false;
        this.objPayloadResponse = result;
        this.ClaimStatusRes = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
        this.showLoading = false;
        this.objSearchReq = new mdlClaimStatusNewReq();
        if (this.ClaimStatusRes.st.StatusCode != "S") {
            swal(this.translate.instant(this.ClaimStatusRes.st.StatusDesc))
            return;
        }
        if(this.ClaimStatusRes.ClaimStatusList.length>0)
        {
          this.ShowClaimStatus = true;
          this.CurrentClaimStatus = new Array<mdlClaimStatusNew>()
          if (this.ClaimStatusRes.ClaimNoList != null && this.ClaimStatusRes.ClaimNoList.length == 1) {
              this.ShowClaimsStatus(this.ClaimStatusRes.ClaimNoList[0]);
          }
        }
        else{
          swal(this.translate.instant("No Records Found"))
        }
        

    });
}

HideClaimStatus() {
    this.ShowClaimStatus = false;
}

ShowClaimsStatus(val) {
    this.TempDocumentList =new Array<mdlCliamDocumentListNew>();
    this.CurrentClaimStatus = new Array<mdlClaimStatusNew>()
    this.CurrentClaimStatus = this.ClaimStatusRes.ClaimStatusList.filter(a => a.CLAIM_NUMBER == val.CLAIM_NUMBER);

}

CloseClaimModal(){
  this.objSearchReq = new mdlClaimStatusNewReq();
  this.SerachByValue ="";
  this.SearchTextValue = "";
}
ClearText(){
  this.objSearchReq = new mdlClaimStatusNewReq();
  this.SearchTextValue = "";
}
CheckClaimDocument(val){
  this.TempDocumentList =new Array<mdlCliamDocumentListNew>();
  this.TempDocumentList = this.ClaimStatusRes.DocumentList.filter(a=>a.CLAIM_NUMBER==val.CLAIM_NUMBER);
}
ClearMobileNo(){
this.regObj.MobileNo=""
}
YakeenMobileNoVerify() {
  
  var req={
    Insured_IdNo:this.regObj.InsuredIdNo,
    MobileNo:this.regObj.MobileNo,
    USerId:"0"
    }
  //alert("Test");
  this.resendObj.RegNo = sessionStorage.getItem("RegNo");

  this.showLoading = true;
  this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(req));

  //this.http.post<MotorStatusMdl>(this.url.baseURL + "Registration/ResendOTP", this.resendObj, this.userInfo.getHttpOptions()).toPromise().then((res) => {
  this.http.post<mdlPayloadResponse>(this.url.baseURL + "/Limra/YakeenMobileNoVerifyDisAuth", this.objPayloadRequest, this.userInfo.getHttpOptions()).toPromise().then((res) => {
    //this.st = res;

    //New Line Start
    this.objPayloadResponse = res;
    this.YakeenMobileres = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
    //NewLine End

   if(this.YakeenMobileres.StatusCode=="S"){
    if (this.YakeenMobileres.isOwner==false) {
      this.Lng == "ar" ? Swal("Please enter the Mobile Number registered in Absher") : Swal("Please enter the Mobile Number registered in Absher");
      this.regObj.MobileNo="";
    }
   }
   else{
    Swal(this.YakeenMobileres.StatusDesc);
   }
    
    this.showLoading = false;
  }, (res) => {
    Swal("Try agian");
    this.showLoading = false;

  });
}


GoToClaimStatus() { 

  this.showLoading = true; 
  const url = "https://njs.ggi-sa.com/online-portal/claims/motor/intimation/claim-status";

  // Use a timeout to simulate a loading period before redirection
  setTimeout(() => {
      window.location.href = url;
      this.showLoading = false; 
  }, 1000); // Adjust the delay as needed 

}

goToUnsubscribe() {
  this.router.navigate(['/BeforeLogin', 'Unsubscribe']);
}

}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/NewReg/NewReg.ts